import { mapNullable } from 'annotation-tools/utils';
import { IRectToRawRectangle } from '../../types/common/raw-rectangle';
import {
  ProjectImageInfoAPIRawRequestBodyType,
  ProjectImageInfoAPIRequestBodyType
} from '../../types/project-image-info/api-request-body';

export const ProjectImageInfoAPIRequestBody = ({
  fileGuid,
  cropRect,
  modelId,
  name
}: ProjectImageInfoAPIRequestBodyType): ProjectImageInfoAPIRawRequestBodyType => ({
  file_guid: fileGuid,
  crop_option: mapNullable(cropRect, IRectToRawRectangle),
  model_id: modelId,
  name
});

export const ProjectImageInfoAPIRequestBodyPartial = ({
  fileGuid,
  cropRect,
  modelId,
  name
}: Partial<
  ProjectImageInfoAPIRequestBodyType
>): Partial<ProjectImageInfoAPIRawRequestBodyType> => ({
  file_guid: fileGuid,
  crop_option: mapNullable(cropRect, IRectToRawRectangle),
  model_id: modelId,
  name
});
